import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import React from 'react';

interface DialogOptions {
  children: React.ReactNode;
}

interface DialogState {
  state: boolean;
  options: DialogOptions;
}

const initialState: DialogState = {
  state: false,
  options: {
    children: 'Hi',
  },
};

const dialogSlice = createSlice({
  name: 'dialog',
  initialState,
  reducers: {
    openDialog: (state, action: PayloadAction<DialogOptions>) => {
      state.state = true;
      state.options = action.payload;
    },
    closeDialog: (state) => {
      state.state = false;
    },
  },
});

export const { openDialog, closeDialog } = dialogSlice.actions;

export const selectFuseDialogState = ({ fuse }: { fuse: { dialog: DialogState } }) =>
  fuse.dialog.state;

export const selectFuseDialogOptions = ({ fuse }: { fuse: { dialog: DialogState } }) =>
  fuse.dialog.options;

export default dialogSlice.reducer;
